import { annexureService } from "../../services/annexure.service";
import { ANNEXURE_PARTS } from "./actionsTypes";
import { apiStart, apiError, apiSuccess } from "./apiActions";

export const deliveryActions = {
    getAnnexureList,
    getAllAnnexureList,
    addAnnxurePart,
    updateAnnexurePart,
    deleteAnnexurePart,
    editAnnexurePart
}

export function getAnnexureList(skip: any, page: any, partNumber: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(ANNEXURE_PARTS.GET_ANNEXURE_PARTS_LIST_FETCHING));
        const response = await annexureService.getAnnexureList(skip,page,partNumber);
        if (response?.error) {
            dispatch(apiError(ANNEXURE_PARTS.GET_ANNEXURE_PARTS_LIST_ERROR, response));
            return response || [];
        } else {
            dispatch(apiSuccess(ANNEXURE_PARTS.GET_ANNEXURE_PARTS_LIST_SUCCESS, response));
            return response || [];
        }
    };
}

export function getAllAnnexureList() {
    return async (dispatch: any) => {
        dispatch(apiStart(ANNEXURE_PARTS.GET_ALL_ANNEXURE_PARTS_LIST_FETCHING));
        const response = await annexureService.getAllAnnexureList();
        if (response?.error) {
            dispatch(apiError(ANNEXURE_PARTS.GET_ALL_ANNEXURE_PARTS_LIST_ERROR, response));
            return response || [];
        } else {
            dispatch(apiSuccess(ANNEXURE_PARTS.GET_ALL_ANNEXURE_PARTS_LIST_SUCCESS, response));
            return response || [];
        }
    };
}

export function editAnnexurePart(partNumber: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(ANNEXURE_PARTS.EDIT_ANNEXURE_PARTS_FETCHING));
        const response = await annexureService.editAnnexurePart(partNumber);
        if (response?.error) {
            dispatch(apiError(ANNEXURE_PARTS.EDIT_ANNEXURE_PARTS_ERROR, response));
            return response || [];
        } else {
            dispatch(apiSuccess(ANNEXURE_PARTS.EDIT_ANNEXURE_PARTS_SUCCESS, response));
            return response || [];
        }
    };
}

export function addAnnxurePart(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(ANNEXURE_PARTS.ADD_ANNEXURE_PARTS_FETCHING));
        const response = await annexureService.addAnnxurePart(data);
        if (response?.error) {
            dispatch(apiError(ANNEXURE_PARTS.ADD_ANNEXURE_PARTS_ERROR, response));
            return response || [];
        } else {
            dispatch(apiSuccess(ANNEXURE_PARTS.ADD_ANNEXURE_PARTS_SUCCESS, response));
            return response || [];
        }
    };
}

export function updateAnnexurePart(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(ANNEXURE_PARTS.UPDATE_ANNEXURE_PARTS_FETCHING));
        const response = await annexureService.updateAnnexurePart(data);
        if (response?.error) {
            dispatch(apiError(ANNEXURE_PARTS.UPDATE_ANNEXURE_PARTS_ERROR, response));
            return response || [];
        } else {
            dispatch(apiSuccess(ANNEXURE_PARTS.UPDATE_ANNEXURE_PARTS_SUCCESS, response));
            return response || [];
        }
    };
}

export function deleteAnnexurePart(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(ANNEXURE_PARTS.DELETE_ANNEXURE_PARTS_FETCHING));
        const response = await annexureService.deleteAnnexurePart(data);
        if (response?.error) {
            dispatch(apiError(ANNEXURE_PARTS.DELETE_ANNEXURE_PARTS_ERROR, response));
            return response || [];
        } else {
            dispatch(apiSuccess(ANNEXURE_PARTS.DELETE_ANNEXURE_PARTS_SUCCESS, response));
            return response || [];
        }
    };
}

export function importAnnexureParts(data?: any, customHeaders?: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(ANNEXURE_PARTS.IMPORT_ANNEXURE_PARTS_FETCHING));
        try {
            const response = await annexureService.importAnnexureParts(data, customHeaders);
            dispatch(apiSuccess(ANNEXURE_PARTS.IMPORT_ANNEXURE_PARTS_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(ANNEXURE_PARTS.IMPORT_ANNEXURE_PARTS_ERROR, error));
            return error;
        }
    };
}